import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, List, ListItemText, Radio, FormControlLabel, ListItemButton, Avatar, Stack } from '@mui/material';
import { useNavigate, useOutletContext } from 'react-router-dom';
import PropertyFooterLayout from '../../../components/properties/PropertyFooterLayout';

const progress = 80;
const step = 2;

type TeamMember = {
  id_Realtor: number;
  fullName: string;
  profileImage: string | null;
};

type PublishOutletContext = {
  handleNavigateToPropertyVisibility: () => void;
  selectedRealtorId: number | null;
  setSelectedRealtorId: (id: number) => void;
  teamMembers: TeamMember[];
  currentRealtorId: number;
};

const PublishPropertyAssigneePage: React.FC = () => {
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const navigate = useNavigate();
  const {
    handleNavigateToPropertyVisibility,
    selectedRealtorId,
    setSelectedRealtorId,
    teamMembers,
    currentRealtorId,
  } = useOutletContext<PublishOutletContext>();

  useEffect(() => {
    setSelectedId(selectedRealtorId || currentRealtorId);
  }, [selectedRealtorId, currentRealtorId]);

  const handleSelection = (id: number) => {
    setSelectedId(id);
    setSelectedRealtorId(id);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleContinue = () => {
    handleNavigateToPropertyVisibility();
  };

  return (
    <Container maxWidth="md" sx={{ display: 'flex', pb: 12, flexDirection: 'column', alignItems: 'center' }}>
      <Box p={4} sx={{ width: '80%' }}>
        <Typography variant="h4" gutterBottom mb={2}>
          Asignar agente para esta publicación
        </Typography>
        <Typography variant="body1" mb={4}>
          Como líder de equipo, puedes asignar esta propiedad a otro miembro de tu equipo o dejarla a tu nombre.
        </Typography>

        <List sx={{ width: '100%' }}>
          {teamMembers.map((member) => (
            <ListItemButton
              key={member.id_Realtor}
              onClick={() => handleSelection(member.id_Realtor)}
              sx={{
                mb: 2,
                p: 2,
                borderRadius: 2,
                border: selectedId === member.id_Realtor ? '2px solid black' : '1px solid grey',
                transition: 'border 0.3s',
                cursor: 'pointer',
              }}
            >
              <FormControlLabel
                control={
                  <Radio
                    checked={selectedId === member.id_Realtor}
                    value={member.id_Realtor}
                    color="success"
                  />
                }
                label={
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Avatar src={member.profileImage || ''} />
                    <ListItemText
                      primary={member.fullName}
                      primaryTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
                    />
                  </Stack>
                }
                sx={{ width: '100%' }}
              />
            </ListItemButton>
          ))}
        </List>
      </Box>

      <PropertyFooterLayout
        progress={progress}
        step={step}
        onBack={handleBack}
        onContinue={handleContinue}
        isContinueDisabled={!selectedId}
      />
    </Container>
  );
};

export default PublishPropertyAssigneePage;
